import { baseStoreCreator } from '@/utils/store';

import { IFieldLevelAccessSetup } from '../../role.types';

export const DEFAULT_VALUES: IFieldLevelAccessSetup = {
  id: '',
  name: '',
  description: '',
  roles: [],
  properties: undefined,
  overridableProperties: undefined,

};

export const useStore = baseStoreCreator<IFieldLevelAccessSetup>(DEFAULT_VALUES);

export default useStore;